var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { MembreRemarque } from 'admin/classes/MembreRemarque.class';
import { Album } from 'album/classes/Album.class';
import axiosInstance from '../../store/AxiosSingleton';
import { Membre } from 'membre/classes/Membre.class';
import { MembreDroit } from 'membre/classes/MembreDroit.class';
import { Sortie } from 'sortie/classes/Sortie.class';
import { RaisonSuppression } from 'admin/classes/RaisonSuppression.class';
import { Alerte } from 'common/classes/Alerte.class';
import { Thematique } from 'forum/classes/Thematique.class';
export class AdminService {
    /**
     * Vérifie si l'utilisateur connecté est un administrateur
     * @return True si l'utilisateur est un administrateur, false sinon
     */
    static checkAdmin() {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.get('/index.php', {
                params: {
                    rub: AdminService.rubModule,
                    action: 'CHECK_ADMIN',
                },
            });
            return content;
        });
    }
    /**
     * Charge tous les membres avec des informations administrateurs
     * @param request Filtres de la requête
     * @return Liste des membres et leur nombre total
     */
    static loadMembers(request) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.get('/index.php', {
                params: Object.assign({ rub: AdminService.rubModule, action: 'ADMIN_LOAD_MEMBERS' }, request),
            });
            return {
                membres: content.membres.map((member) => new Membre(member.infoPublic, member.infoPrive, member.infoAdmin)),
                total: content.total,
            };
        });
    }
    /**
     * Charger un membre avec les informations publiques, privées et admin
     * @param idMembre Identifiant du membre
     * @return Membre avec toutes ses informations
     */
    static loadMember(idMembre) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.get('/index.php', {
                params: {
                    rub: AdminService.rubModule,
                    action: 'ADMIN_LOAD_MEMBER',
                    idMembre,
                },
            });
            return new Membre(content.infoPublic, content.infoPrive, content.infoAdmin);
        });
    }
    /**
     * Bloque les emails fournis
     * @param emails Liste des emails à bloquer
     * @return Les emails qui n'ont pas pu être bloqués
     */
    static blockEmails(emails) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.post('/index.php', {
                emails,
            }, {
                params: {
                    rub: AdminService.rubModule,
                    action: 'ADMIN_BLOCK_EMAILS',
                },
            });
            return content;
        });
    }
    /**
     * Change l'état de mailKO
     * @param idMembre Identifiant du membre
     * @return True si action réussie, false sinon.
     */
    static switchEmailKo(idMembre) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.post('/index.php', { idMembre }, {
                params: {
                    rub: AdminService.rubModule,
                    action: 'ADMIN_SWITCH_EMAIL_KO',
                },
            });
            return content;
        });
    }
    /**
     * Rend un membre premium ou lui enlève la fonctionnalité premium
     * @param idMembre Identifiant du membre
     * @return True si l'opération a fonctionné
     */
    static switchPremium(idMembre) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.post('/index.php', {
                idMembre,
            }, {
                params: {
                    rub: AdminService.rubModule,
                    action: 'ADMIN_SWITCH_PREMIUM',
                },
            });
            return content;
        });
    }
    /**
     * Charge les remarques d'un membre
     * @param idMembre Identifiant du membre
     * @return Remarques récupérées
     */
    static loadMemberRemarque(idMembre) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.get('/index.php', {
                params: {
                    rub: AdminService.rubModule,
                    action: 'ADMIN_LOAD_MEMBER_REMARQUES',
                    idMembre,
                },
            });
            return content.map((remarque) => new MembreRemarque(remarque));
        });
    }
    /**
     * Ajoute une remarque à un membre
     * @param request Identifiant du membre et le message de la remarque à ajouter
     * @return La remarque ajoutée
     */
    static addMemberRemarque(request) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.post('/index.php', { request }, {
                params: {
                    rub: AdminService.rubModule,
                    action: 'ADMIN_ADD_MEMBER_REMARQUE',
                },
            });
            return content.map((remarque) => new MembreRemarque(remarque));
        });
    }
    /**
     * Supprime le membre
     * @param idMembre Identifiant du membre à supprimer
     * @param idRaison Identifiant de la raison de la suppression
     * @param commentaire *(optionnel)* Commentaire de la suppression
     * @return True si l'opération a réussie
     */
    static deleteMember(idMembre, idRaison, commentaire) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.delete('/index.php', {
                params: {
                    rub: AdminService.rubModule,
                    action: 'ADMIN_DELETE_MEMBER',
                    idMembre,
                    idRaison,
                    commentaire,
                },
            });
            return content;
        });
    }
    /**
     * Débanni un membre
     * @param idMembre Identifiant du membre
     * @return True si l'opération a fonctionné
     */
    static undeleteMember(idMembre) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.post('/index.php', {
                idMembre,
            }, {
                params: {
                    rub: AdminService.rubModule,
                    action: 'ADMIN_UNDELETE_MEMBER',
                },
            });
            return content;
        });
    }
    /**
     * Modifie le rôle d'un membre
     * @param request L'identifiant du membre et l'identifiant du droit qu'on souhaite lui attribuer
     * @return True si la modification a réussie
     */
    static changeMemberRole(request) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.post('/index.php', { request }, {
                params: {
                    rub: AdminService.rubModule,
                    action: 'ADMIN_CHANGE_MEMBER_ROLE',
                },
            });
            return content;
        });
    }
    /**
     * Créer un compte pour un utilisateur
     * @param member Membre à créer
     * @return True si l'envoi du mail de création de compte a réussi
     */
    static addMember(member) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.post('/index.php', { member }, {
                params: {
                    rub: AdminService.rubModule,
                    action: 'ADMIN_ADD_MEMBER',
                },
            });
            return content;
        });
    }
    /**
     * Charge les albums avec des informations administrateurs
     * @param request Filtres à appliquer
     * @return Albums chargés, sorties en lien et nombre total d'albums
     */
    static loadAlbums(request) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.get('/index.php', {
                params: {
                    rub: AdminService.rubModule,
                    action: 'ADMIN_LOAD_ALBUMS',
                    request,
                },
            });
            return {
                albums: content.albums.map((album) => new Album(album)),
                total: content.total,
                sorties: (_b = (_a = content === null || content === void 0 ? void 0 : content.sorties) === null || _a === void 0 ? void 0 : _a.map((sortie) => new Sortie(sortie))) !== null && _b !== void 0 ? _b : null,
            };
        });
    }
    /**
     * Cherche des albums en fonction de filtres
     * @param request Filtres à appliquer
     * @return Albums trouvés
     */
    static searchAlbums(request) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.get('/index.php', {
                params: Object.assign({ rub: AdminService.rubModule, action: 'ADMIN_SEARCH_ALBUMS' }, request),
            });
            return content.map((album) => new Album(album));
        });
    }
    /**
     * Charge les statistiques des albums pour un membre donné
     * @param idMembre Identifiant du membre
     * @return Statistiques récupérées
     */
    static loadAlbumsStatistics(idMembre) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.get('/index.php', {
                params: {
                    rub: AdminService.rubModule,
                    action: 'ADMIN_LOAD_ALBUMS_STATISTICS',
                    idMembre,
                },
            });
            return content;
        });
    }
    /**
     * Récupère le nom des sorties créées par le membre
     * @param idMembre Identifiant du membre
     * @return Identifiant et nom des sorties
     */
    static loadMemberSortieNameList(idMembre) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.get('/index.php', {
                params: {
                    rub: AdminService.rubModule,
                    action: 'ADMIN_LOAD_MEMBER_SORTIE_NAME_LIST',
                    idMembre,
                },
            });
            return content;
        });
    }
    /**
     * Valide un album
     * @param album Album validé
     * @param notifications Notification à envoyer à l'auteur de l'album
     * @param sendMail Si true envoi un mail aux contacts de l'auteur de l'album
     * @return true si action réussie
     */
    static validateAlbum(album, notifications, sendMail) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.post('/index.php', {
                album: album.toRaw(),
                notifications,
                sendMail,
            }, {
                params: {
                    rub: AdminService.rubModule,
                    action: 'ADMIN_VALIDATE_ALBUM',
                },
            });
            return content;
        });
    }
    /**
     * On récupère tous les rôles en dessous de celui de l'utilisateur connecté
     * @return Rôles récupérés
     */
    static loadMemberRoles() {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.get('/index.php', {
                params: {
                    rub: AdminService.rubModule,
                    action: 'ADMIN_LOAD_MEMBER_ROLE',
                },
            });
            return content.map((membreDroit) => new MembreDroit(membreDroit));
        });
    }
    /**
     * Renvoi toutes les statistiques des sorties de l'application
     * @return Statistiques récupérées
     */
    static loadSortiesStatistics() {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.get('/index.php', {
                params: {
                    rub: AdminService.rubModule,
                    action: 'ADMIN_LOAD_SORTIES_STATISTICS',
                },
            });
            return content;
        });
    }
    /**
     * Récupère en BDD les sorties d'un membre en fonction de filtres
     * @param request Paramètre de la requête vers le back
     * @return La liste des sorties et le nombre de total de sorties
     */
    static adminLoadSorties(request) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.get('/index.php', {
                params: {
                    rub: AdminService.rubModule,
                    action: 'ADMIN_LOAD_SORTIES',
                    request,
                },
            });
            return {
                sorties: content.sorties.map((sortie) => new Sortie(sortie)),
                total: content.total,
            };
        });
    }
    /**
     * Récupère une sortie avec des informations administrateurs
     * @param idSortie Identifiant de la sortie
     * @return Sortie récupérée
     */
    static loadSortie(idSortie) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.get('/index.php', {
                params: {
                    rub: AdminService.rubModule,
                    action: 'ADMIN_LOAD_SORTIE',
                    idSortie,
                },
            });
            return new Sortie(content);
        });
    }
    /**
     * Valide une sortie en BDD
     * @param sortie Sortie à valider
     * @param notification Dictionnaire des notifications
     * @param sendMail Si true envoi un mail aux contacts de l'auteur de l'album
     * @return True si validation réussi, false sinon
     */
    static validateSortie(sortie, notification, sendMail) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!sortie) {
                return false;
            }
            const { data: { content }, } = yield axiosInstance.post('/index.php', {
                sortie: sortie.toRaw(),
                notification,
                sendMail,
            }, {
                params: {
                    rub: AdminService.rubModule,
                    action: 'ADMIN_VALIDATE_SORTIE',
                },
            });
            return content;
        });
    }
    /**
     * Charge la liste des raisons de suppressions
     * @param rubrique Rubrique dont on souhaite charger les raisons
     * @return La liste des raisons de suppressions
     */
    static loadRaisonSuppression(rubrique) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.get('/index.php', {
                params: {
                    rub: AdminService.rubModule,
                    action: 'LOAD_RAISON_SUPPRESSION',
                    rubrique,
                },
            });
            return content.map((p) => new RaisonSuppression(p));
        });
    }
    /**
     * Charge les alertes recencées dans l'application en fonction de filtres
     * @param request Filtres de la requête
     * @return Alertes récupérées et nombre d'alertes total
     */
    static loadAlertes(request) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.get('/index.php', {
                params: Object.assign({ rub: AdminService.rubModule, action: 'ADMIN_LOAD_ALERTES' }, request),
            });
            return {
                alertes: content.alertes.map((alerte) => new Alerte(alerte)),
                total: content.total,
            };
        });
    }
    /**
     * Traiter une alerte
     * @param idAlerte Identifiant de l'alerte
     * @return True si l'opération a réussi, false sinon
     */
    static moderateAlerte(idAlerte) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.post('/index.php', { idAlerte }, {
                params: {
                    rub: AdminService.rubModule,
                    action: 'ADMIN_MODERATE_ALERTE',
                },
            });
            return content;
        });
    }
    /**
     * Récupère les thématiques du forum
     * @param request filtre de la recherche
     * @return La liste des thématiques
     */
    static adminLoadThematique(request) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.get('/index.php', {
                params: {
                    rub: AdminService.rubModule,
                    action: 'ADMIN_LOAD_THEMATIQUES',
                    request,
                },
            });
            return content.map((thematique) => new Thematique(thematique));
        });
    }
    /**
     * Récupère des statistiques sur le forum
     * @return Statistiques récupérées
     */
    static adminLoadForumStats() {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.get('/index.php', {
                params: {
                    rub: AdminService.rubModule,
                    action: 'ADMIN_LOAD_FORUM_STATS',
                },
            });
            return content;
        });
    }
    /**
     * Ajoute une nouvelle thématique
     * @param thematique Thematique à insérer
     * @return True si l'opération a fonctionné, false sinon
     */
    static addForumThematique(thematique) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!thematique) {
                return false;
            }
            const { data: { content }, } = yield axiosInstance.post('/index.php', {
                thematique,
            }, {
                params: {
                    rub: AdminService.rubModule,
                    action: 'ADMIN_SAVE_FORUM_THEMATIQUE',
                },
            });
            return content;
        });
    }
    /**
     * Supprime une thématique
     * @param request Informations relatives à la suppression
     * @return True si suppression réussi, false sinon
     */
    static deleteThematique(request) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!request) {
                return false;
            }
            const { data: { content }, } = yield axiosInstance.post('/index.php', {
                request,
            }, {
                params: {
                    rub: AdminService.rubModule,
                    action: 'ADMIN_DELETE_FORUM_THEMATIQUE',
                },
            });
            return content;
        });
    }
    /**
     * Met à jour la relation d'une sortie avec un album
     * @param sortie Sortie à modifier
     * @return True si modification réussie, false sinon
     */
    static adminUpdateSortieLinkedAlbum(sortie) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!sortie) {
                return false;
            }
            const { data: { content }, } = yield axiosInstance.post('/index.php', {
                sortie: sortie.toRaw(),
            }, {
                params: {
                    rub: AdminService.rubModule,
                    action: 'ADMIN_UPDATE_SORTIE_LINKED_ALBUM',
                },
            });
            return content;
        });
    }
}
AdminService.rubModule = 'admin';
//# sourceMappingURL=data:application/json;base64,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